"use client";

import {JSX, ReactNode} from "react";

import classNames from "classnames";

import {type SpaceProps, useSectionSpace} from "@/sections/use-section-space";

import {RawEmbedSection} from "@/shared/ui/data-display/raw-embed/raw-embed-iframe";
import {Typography} from "@/shared/ui/data-display/typography";
import {ContainerBase} from "@/shared/ui/layout/container-base";

import "./styles/start-franchise.scss";

interface StartFranchiseProps {
    space?: SpaceProps;
    title: string;
    children?: ReactNode;
    background?: "silver" | "white";
    className?: string;
    anchorId?: string;
    customCss?: string;
    formEmbed?: string;
}

export function StartFranchise({
    space,
    children,
    background = "silver",
    className,
    title,
    anchorId,
    customCss,
    formEmbed,
}: StartFranchiseProps): JSX.Element {
    const sectionSpace = useSectionSpace(space);

    return (
        <section
            className={classNames("start-franchise", `start-franchise-${background}`, className)}
            aria-label="Start Franchise"
            id={anchorId}
            style={sectionSpace}
        >
            <ContainerBase className="start-franchise__wrap">
                {children && (
                    <div className="start-franchise__wrap-left">
                        <Typography as="h2" size={20} lineHeight={120} className="start-franchise__title" innerHTML={title}></Typography>
                        {children}
                    </div>
                )}
                <div className="start-franchise__wrap-right">
                    <Typography as="h2" size={18} lineHeight={120} className="start-franchise__title-mobile" innerHTML={title}></Typography>
                    {formEmbed && <RawEmbedSection html={formEmbed} css={customCss} scopeKey={anchorId || title} />}
                </div>
            </ContainerBase>
        </section>
    );
}
